module.exports = __webpack_public_path__ + "static/media/asset_stolen_warning.f6e4c43b.svg";